import {
    IErpPackageDetails,
    SetManagePackageDetails,
    SetManagePackageOpened,
    SET_MANAGE_PACKAGE_DETAILS,
    SET_MANAGE_PACKAGE_OPENED,
} from "./erp-packages-types";

export const setManagePackageOpened = (
    isManagePackageOpened: boolean
): SetManagePackageOpened => ({
    type: SET_MANAGE_PACKAGE_OPENED,
    isManagePackageOpened: isManagePackageOpened,
});

export const setManagePackageDetails = (
    packageDetails: IErpPackageDetails
): SetManagePackageDetails => ({
    type: SET_MANAGE_PACKAGE_DETAILS,
    packageDetails: packageDetails,
});
